const SortByList = [
  { value: "created_at", label: "Posted Date" },
  { value: "pick_up_date", label: "Pick up Date" },
  { value: "drop_off_date", label: "Drop off Date" },
];

export { SortByList };
